export default __webpack_public_path__ + "static/media/gallery_03.76834e1d.jpg";